import React from "react"
import { Link } from "gatsby"

interface ButtonProp {
  buttonString: string
  buttonURL: string
  external?: Boolean
  contactfrom?: Boolean
  hideNoreferrer?: Boolean
  black?: Boolean
}

function Button({
  external = false,
  contactfrom = false,
  buttonURL = "/",
  hideNoreferrer,
  buttonString = "Placeholder",
  black = false,
}: ButtonProp) {
  const baseClasses =
    "cursor-pointer font-family[inherit] text-white px-5 py-2.5 my-1 text-center font-medium border-0 rounded-sm hover:outline hover:outline-1 hover:outline-offset-1 inline-block"
  const btnClasses = `${baseClasses} bg-fehr-500 hover:bg-white hover:text-fehr-600 hover:outline-fehr-600`
  const blackClasses = `${baseClasses} bg-black hover:bg-white hover:text-black hover:outline-black`
  const contactFormClasses = `${baseClasses} !text-fehr-600 bg-white hover:bg-fehr-500 hover:!text-white hover:outline-white`

  const className = contactfrom
    ? contactFormClasses
    : black
      ? blackClasses
      : btnClasses

  return external ? (
    <a
      href={buttonURL}
      className={className}
      target="_blank"
      rel={hideNoreferrer ? "noopener" : "noopener noreferrer"}
    >
      {buttonString}
    </a>
  ) : (
    <Link className={className} to={buttonURL}>
      {buttonString}
    </Link>
  )
}

export default Button
